import PriceStackLuxPlusProminentPrice from 'LuxKit/PricePoints/LuxPlus/PriceStackLuxPlusProminentPrice'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits, getIsFreePreviewLuxPlusMember, getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice from 'LuxKit/PricePoints/PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice'

interface Props {
  price: number
  memberPrice?: number
  offerConfig?: App.OfferLuxPlusConfig
}

function PackageUpgradePriceStack(props: Props) {
  const {
    offerConfig,
    price,
    memberPrice = 0,
  } = props

  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const isFreePreviewLuxPlusMember = useAppSelector(getIsFreePreviewLuxPlusMember)
  const canFreePreviewBuyMemberOnly = isFreePreviewLuxPlusMember && offerConfig?.restrictPurchaseToMembers === false
  const displayedMode = useMemo(() => {
    if (!luxPlusEnabled) {
      return 'regular-only'
    } else if (offerConfig?.access === 'memberOnly') {
      // Must be checked before the generic regular-prominent branch below — otherwise a
      // non-member viewing a member-only offer (which always has a real memberPrice > 0) would
      // see both prices side by side instead of just the member price they can't redeem.
      return 'member-only'
    } else if (!canViewLuxPlusBenefits && memberPrice > 0) {
      return 'regular-prominent'
    } else if (canViewLuxPlusBenefits && memberPrice > 0) {
      return 'member-prominent'
    } else {
      return 'regular-only'
    }
  }, [canViewLuxPlusBenefits, offerConfig?.access, luxPlusEnabled, memberPrice])
  switch (displayedMode) {
    case 'regular-only':
      return <PriceRowPrice
        price={price}
        saleUnit=""
        size="M"
        signDisplay="always"
      />
    case 'member-only':
      if (canFreePreviewBuyMemberOnly) {
        return <PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice
          memberPrice={memberPrice || price}
          saleUnit=""
          nonMemberPrice={price}
          size="M"
          signDisplay="always"
          orientation="vertical"
          horizontalAlign="start"
        />
      }
      return <PriceRowLuxPlusPrice
        memberPrice={memberPrice || price}
        size="M"
        saleUnit=""
        signDisplay="always"
        logoPlacement="trailing"
      />
    case 'member-prominent':
      return <PriceStackLuxPlusProminentPrice
        memberPrice={memberPrice}
        saleUnit=""
        nonMemberPrice={price}
        size="M"
        memberPriceSignDisplay="always"
        nonMemberPriceSignDisplay="always"
        orientation="vertical"
        horizontalAlign="start"
      />
    case 'regular-prominent':
      return <PriceStackPriceWithLoyaltyLeadWithLuxPlusPrice
        memberPrice={memberPrice}
        saleUnit=""
        nonMemberPrice={price}
        size="M"
        signDisplay="always"
        horizontalAlign="start"
        orientation="vertical"
      />
  }
}

export default PackageUpgradePriceStack
